<template>
  <v-app>
    <v-main>
      <v-container>
        <v-layout justify-center>
          <v-flex xs12 sm12 md12 lg12 xl6>
            <v-card-title class="pb-5">
              <!--                                    v-if="$can('transaction_create')"-->
              <!--              <v-btn @click="$router.push({name: 'admin.customers'})" class="btn-back">-->
              <!--                <span class="flaticon2-reply icon-lg"></span>-->
              <!--                بازگشت-->
              <!--              </v-btn>-->
              <!--              <v-spacer/>-->
              <!--              {{ $t($route.meta.title) }}-->
              <!--              <v-spacer/>-->
              <v-btn
                @click="updateCustomer"
                :loading="loading"
                class="btn-update"
              >
                <v-icon>mdi-update</v-icon>
                بروزرسانی
              </v-btn>
              <!--                            <v-card elevation="2" outlined>-->
            </v-card-title>
            <v-card-text>
              <hr class="pb-3" />
              <v-row>
                <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                  <v-text-field
                    label="نام"
                    outlined
                    dense
                    disabled
                    readonly
                    v-model="data.first_name"
                    :error-messages="errors.first_name"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                  <v-text-field
                    label="نام خانوادگی"
                    outlined
                    dense
                    disabled
                    v-model="data.last_name"
                    readonly
                    :error-messages="errors.last_name"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                  <v-text-field
                    label="نام پدر"
                    outlined
                    dense
                    v-model="data.fathers_name"
                    @keydown="isStringKey"
                    counter
                    maxlength="40"
                    :error-messages="errors.fathers_name"
                  ></v-text-field>
                </v-flex>
              </v-row>
              <v-row>
                <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                  <v-text-field
                    label="شغل"
                    outlined
                    dense
                    v-model="data.job"
                    :error-messages="errors.job"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                  <v-text-field
                    label="کدملی"
                    outlined
                    dense
                    disabled
                    readonly
                    :value="data.national_code"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                  <v-text-field
                    label="شماره شناسنامه"
                    outlined
                    dense
                    v-model="data.verify_id"
                    @keydown="isNumericKey"
                    counter
                    maxlength="11"
                    :error-messages="errors.verify_id"
                  ></v-text-field>
                </v-flex>
              </v-row>
              <v-row>
                <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                  <v-text-field
                    label="شماره تلفن"
                    outlined
                    dense
                    v-model="data.telephone"
                    @keydown="isNumericKey"
                    counter
                    maxlength="11"
                    :error-messages="errors.telephone"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                  <date-picker
                    label="تاریخ تولد"
                    view="year"
                    format="YYYY-MM-DD"
                    display-format="jYYYY-jMM-jDD"
                    max="2006-01-01"
                    start="2006-01-01"
                    v-model="data.birth_day"
                  />
                </v-flex>
                <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                  <v-text-field
                    label="محل تولد"
                    outlined
                    dense
                    v-model="data.place_birth"
                    :error-messages="errors.place_birth"
                  ></v-text-field>
                </v-flex>
              </v-row>
              <v-row>
                <v-flex class="p-2 d-flex d-inline" xs12 sm12 md4 lg4 xl4>
                  <v-autocomplete
                    :items="provinces"
                    item-text="name"
                    v-model="data.province"
                    :error-messages="errors.province"
                    item-value="id"
                    label="استان"
                    dense
                    outlined
                  >
                    <template slot="item" slot-scope="{ item }">{{
                      item.name
                    }}</template>
                  </v-autocomplete>
                </v-flex>
                <v-flex class="p-2 d-flex d-inline" xs12 sm12 md4 lg4 xl4>
                  <v-text-field
                    label="شماره موبایل"
                    outlined
                    dense
                    v-model="data.phone_number"
                    @keydown="isNumericKey"
                    counter
                    maxlength="11"
                    :error-messages="errors.phone_number"
                  ></v-text-field>
                  <v-btn
                    icon
                    v-if="!showOtherPhone && data.other_phone === null"
                    rounded
                    class="mr-2 btn-add-with-text"
                    style="top: -9px !important"
                    @click="showOtherPhone = !showOtherPhone"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex
                  v-if="showOtherPhone || data.other_phone !== null"
                  class="p-2 d-flex d-inline"
                  xs12
                  sm12
                  md4
                  lg4
                  xl4
                >
                  <v-text-field
                    label="شماره دیگر"
                    outlined
                    dense
                    v-model="data.other_phone"
                    @keydown="isNumericKey"
                    counter
                    maxlength="11"
                    :error-messages="errors.other_phone"
                  ></v-text-field>
                  <v-btn
                    icon
                    @click="(showOtherPhone = false), (data.other_phone = null)"
                    rounded
                    class="mr-2 btn-exit"
                    style="top: -9px !important"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-flex>
              </v-row>
              <v-row>
                <v-flex class="p-2" xs12 sm12 md6 lg6 xl6>
                  <v-textarea
                    label="آدرس"
                    outlined
                    dense
                    v-model="data.address"
                    :error-messages="errors.address"
                  ></v-textarea>
                </v-flex>
                <v-flex class="p-2" xs12 sm12 md6 lg6 xl6>
                  <v-textarea
                    label="توضیحات"
                    outlined
                    dense
                    disabled
                    readonly
                    :value="data.description"
                  ></v-textarea>
                </v-flex>
              </v-row>

              <v-row>
                <v-flex class="p-2" xs12 sm12 md6 lg6 xl6>
                  <v-radio-group
                    class="center align-content-center"
                    label="کمپین"
                    v-model="data.send_sms"
                    row
                  >
                    <v-radio label="فعال" value="1"></v-radio>
                    <v-radio label="غیرفعال" value="0"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-row>
            </v-card-text>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Provinces from "@/Provinces.json";
export default {
  name: "Edit",
  props: ["id"],
  data() {
    return {
      loading: false,
      errors: [],
      provinces: [],
      showOtherPhone: false,
      data: {
        first_name: null,
        last_name: null,
        province: null,
        verify_id: null,
        fathers_name: null,
        job: null,
        national_code: null,
        address: null,
        send_sms: null,
        place_birth: null,
        birth_day: null,
        phone_number: null,
        other_phone: null,
        telephone: null,
        description: null,
      },
    };
  },
  methods: {
    getCustomer() {
      this.requestApiGet(`customers/${this.id}`).then(({ data }) => {
        this.data = { ...data.data };
        this.data.send_sms = data.data.send_sms.toString();
      });
    },
    updateCustomer() {
      this.$modal.showLoading();
      this.loading = true;
      this.requestApiPut(`customers/${this.id}`, { ...this.data })
        .then(({ data }) => {
          this.$modal.hideLoading();
          this.$router.push({ name: "admin.customers" });
          this.$toast.success("مشتری با موفقیت به روز رسانی شد.");
        })
        .catch(({ response }) => {
          this.loading = false;
          this.$modal.hideLoading();
          this.errors = response.data.errors;
        });
    },
  },
  mounted() {
    this.getCustomer();
    this.provinces = Provinces;
  },
};
</script>

<style scoped></style>
